import { Button } from '@nesso/ui/primitives/button';

import type { PracticeLocation } from '@/entities/practice';
import { SettingsRow } from '@/shared/ui/settings/settings-row';

import { useSaveLocationForm } from '../model/use-save-location-form';
import { SaveLocationFields } from './save-location/save-location-fields';

type Props = {
    // Present in edit mode, prefilling the row from an existing location. Absent, this renders
    // the add-location row instead.
    location?: PracticeLocation;
    onCancel: () => void;
    onSuccess: (name: string) => void;
};

// Inline settings row, not a dialog — the add/edit state replaces the location's row in place,
// dimming every other row on the page. Follows `settings-editable-row.tsx`'s editing branch.
export function SaveLocation({ location, onCancel, onSuccess }: Props) {
    const isEditing = Boolean(location);
    const saveLocation = useSaveLocationForm({ location, onSuccess });

    return (
        <SettingsRow
            label={location?.name ?? 'New location'}
            action={{ label: 'Cancel', onClick: onCancel }}
        >
            <form onSubmit={saveLocation.onSubmit} className="flex w-full flex-col gap-6">
                <SaveLocationFields form={saveLocation} />
                <div>
                    <Button type="submit" size="lg" disabled={saveLocation.isPending}>
                        {isEditing ? 'Save' : 'Add Location'}
                    </Button>
                </div>
            </form>
        </SettingsRow>
    );
}
